import React from "react";
import PropTypes from "prop-types";

import { OrderObject, CurrentUserObject } from "../Queries/OrderQuery";
import ShipmentsDropdown from "./ShipmentsDropdown";
import ShipmentsModalWrapper from "./ShipmentsModalWrapper";

class CombinedShipmentsDropdown extends React.Component {
  render() {
    return (
      <ShipmentsModalWrapper {...this.props}>
        {(toggleCreateShipmentPopup) => (
          <ShipmentsDropdown
            {...this.props}
            showCreateOption={true}
            toggleCreateShipmentPopup={toggleCreateShipmentPopup}
          />
        )}
      </ShipmentsModalWrapper>
    );
  }
}

CombinedShipmentsDropdown.propTypes = {
  order: OrderObject.isRequired,
  awaitingCallPending: PropTypes.bool.isRequired,
  currentUser: CurrentUserObject.isRequired
};

export default CombinedShipmentsDropdown; 